module.exports = __webpack_public_path__ + "img/fxpaygate.e0742a72.svg";